import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CommonService } from '../common/common.service';
import { SnapshotService } from 'src/app/modules/snapshot/services/snapshot.service';
import { ConfigService } from '../config/config.service';

@Injectable({
	providedIn: 'root',
})
export class SnapshotGuard implements CanActivate {
	constructor(
		private configService: ConfigService,
		public commonService: CommonService,
		private snapshotService: SnapshotService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
		return this.snapshotService.isAvailable().then((isSnapsotEnabledOnHypothesis) => {
			if (isSnapsotEnabledOnHypothesis) {
				return true;
			} else {
				return this.commonService.isFirstPageLoaded()
					? false
					: this.configService.defaultRoute;
			}
		});
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(childRoute, state);
	}
}
